import { Rate as AntRate } from "antd";
import { StarIcon } from "assets/icons";
import "./style.scss";

function Rate({ value, onChange }) {
  return (
    <AntRate
      allowClear
      character={<StarIcon />}
      value={value}
      onChange={onChange}
    />
  );
}

export default Rate;
